export default __webpack_public_path__ + "static/media/arm.8dc15c02.png";